<template>
  <div class="container-fluid">
    <div class="row d-flex justify-content-center">
      <div class="col-lg-10">
        <h1 class="heading-color text-center p-5">1868</h1>
      </div>
    </div>
    <div class="row d-flex justify-content-center" v-if="this.$store.getters.apiStatus !== 'loading'">
      <div class="col-lg-10">
        <div class="overlay">
          <div class="main-loader">
            <MainLoader></MainLoader>
          </div>
        </div>
        <div class="row">
          <ItemCard v-for="category in categories" :key="category.id" :item="category" :nextLink="getNextLink(category.id)"></ItemCard>
        </div>
      </div>
    </div>
    <div class="main-loader" v-else>
      <MainLoader></MainLoader>
    </div>
  </div>
</template>

<script>
import C1868Category from '@/models/C1868Category'
import ItemCard from '@/components/ItemCard'
export default {
  name: 'C1868Categories',
  components: {
    ItemCard
  },
  data () {
    return {
      categories: null,
      PRODUCT_1868_CATEGORY_ID: process.env.PRODUCT_1868_CATEGORY_ID
    }
  },
  mounted () {
    this.fetchC1868Categories()
  },
  methods: {
    fetchC1868Categories () {
      this.categories = []
      $('.overlay').removeClass('d-none')
      this.$store.dispatch('fetchC1868Categories')
        .then((result) => {
          result.data.c1868_categories.forEach(category => {
            this.categories.push(new C1868Category(category))
          })
          $('.overlay').addClass('d-none')
        })
        .catch((err) => console.log(err))
    },
    getNextLink (categoryId) {
      if (categoryId === this.PRODUCT_1868_CATEGORY_ID) {
        return '/category/' + categoryId + '/sub-categories'
      }
      return '/category/' + categoryId + '/c1868s'
    }
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/C1868Categories.vue